// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"01d637ee","296":"1f50b18c","730":"d38f2398"}[chunkId] + ".chunk.css";
};